import { INTERNAL_LINKS } from 'enum';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectStoreCurrentAuthUser } from '../../utils/storeSelectors';
import SentryRoute from '../SentryRoute';

const PublicRoute = props => {
  const history = useHistory();
  const authUser = useSelector(selectStoreCurrentAuthUser);

  useEffect(() => {
    if (authUser) {
      history.push(INTERNAL_LINKS.DASHBOARD);
    }

    // eslint-disable-next-line
  }, []);

  if (authUser) return [];

  return <SentryRoute {...props} />;
};

export default PublicRoute;
